import type { Interpolation } from "@emotion/react";

import type { ThemeType } from "../../../../global/emotion";
import {
  numericPercentages,
  numericValues,
  radius,
  spacing,
} from "../../../../global/emotion";

export const baseStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  backgroundColor: theme.semanticColors.background,
  borderRadius: radius.m,
  color: theme.semanticColors.primary,
  cursor: "pointer",
  display: "flex",
  gap: spacing.ms,
  justifyContent: "space-between",
  opacity: 1,
  paddingBottom: spacing.s,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.s,
  width: numericPercentages[100],
  ":hover": {
    backgroundColor: theme.semanticColors.neutralsLowest,
  },
  ":focus": {
    backgroundColor: theme.semanticColors.neutralsLowest,
    opacity: numericValues[0.6],
  },
  ":active": {
    backgroundColor: theme.semanticColors.neutralsLowest,
    opacity: numericValues[0.6],
  },
});
export const contentStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  gap: spacing.t,
  width: spacing.t,
};
export const disabledStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.semanticColors.background,
  cursor: "not-allowed",
  opacity: numericValues[0.5],
});
export const metaDataStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  color: theme.semanticColors.neutralsMedium,
  display: "flex",
  gap: spacing.xs,
  maxWidth: numericPercentages[100],
});
export const imageStyle: Interpolation = {
  borderRadius: radius.s,
  height: spacing.xxxl,
  objectFit: "cover",
  width: spacing.xxxl,
};
